// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7y-0";
export var startPickingButton = "_7y-1";